export const calculateTopPaddingFilter = () => {
	const defaultTopPadding = 30
	const topMenuContainer: HTMLElement | null = document.querySelector('#top-menu-container')
	if (!topMenuContainer) {
		return
	}

	const elements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-auto-top-padding')
	const height = topMenuContainer.offsetHeight
	for (let i = 0; i < elements.length; i++) {
		const element = elements[i]
		element.style.paddingTop = `${defaultTopPadding + height}px`
	}
}
